import type { PublicTrustSnapshot } from '../types';
import { getWebsiteUrl } from '../config';
import {
  trustStatusCardDetail,
} from '../trustCopy';
import {
  sealNamesEuAiAct,
  trustSealState,
  TRUST_STATUS_STYLES,
} from '../trustSeal';
import { TrustHeroSeal } from './TrustHeroSeal';

/** Seal and live status in one strip sized to its content. */
export function TrustLiveStatusPanel({
  snapshot,
}: {
  snapshot: PublicTrustSnapshot;
}) {
  const state = trustSealState(snapshot);
  const statusStyles = TRUST_STATUS_STYLES[state];
  // No count cell: the seal and the hero line already print the count whenever
  // it is at or above the display floor (24h, or 30d when 24h is quiet), so a
  // third copy only repeated them (Leo, 2026-10-30).
  const complyedgeUrl = getWebsiteUrl();

  return (
    // Sized to its content (sm:w-fit), never the page width: a full-width card
    // held one small seal and left two wide empty bands (Leo, 2026-10-30: "why
    // such a big card"). Seal | status on sm+, stacked on a phone, a hairline between.
    <div className="trust-panel mx-auto w-full overflow-hidden rounded-2xl sm:w-fit">
      <div className="flex flex-col divide-y divide-white/10 sm:flex-row sm:divide-x sm:divide-y-0">
        <div className="flex items-center justify-center px-6 py-5">
          <TrustHeroSeal
            snapshot={snapshot}
            href={complyedgeUrl}
            // The link opens the website; nothing there verifies this seal, so the
            // label never says "verify" (CE-REVIEW-TRUST-012 F2).
            linkLabel="ComplyEdge enforcement seal: opens complyedge.io"
          />
        </div>

        {/* The seal already names the law and the state, so this cell says
            what the seal does not: what is happening right now. */}
        <div className="px-6 py-5 text-center sm:text-left">
          <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-gray-400">
            Status
          </p>
          <p className="mt-2 flex items-center justify-center gap-2 text-sm font-medium text-white sm:justify-start">
            <span className={`inline-flex h-2 w-2 shrink-0 rounded-full ${statusStyles.dot}`} />
            {trustStatusCardDetail(state, sealNamesEuAiAct(snapshot))}
          </p>
        </div>

      </div>
    </div>
  );
}
